<template>
  <div class="scroll">
    <table class="tableFeedback">
      <thead class="thead">
        <tr class="column-main">
          <th v-for="column of columns" :key="column" class="column-main-title">
            <img
              v-if="column.label !== ''"
              class="column-main-title-img"
              :src="require(`@/assets/icons/${column.label}.png`)"
              alt=""
            />
          </th>
        </tr>
      </thead>
      <tbody class="tbody">
        <tr v-for="i of sortedData" :key="i.name" class="column-content">
          <td
            v-for="column of columns"
            :key="column"
            class="column-content-title"
          >
            <span
              :class="{
                'column-content-title-sum':
                  column.value === 'all' || i.label === $t('total')
              }"
            >
              {{ getColumnValue(i, column) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div ref="observer" class="observer"></div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { mapState } from 'vuex';

import {
  FeedbackType,
  TableDataStatistics
} from '@/store/modules/orders/types';
import { Option } from '@/types';

@Options({
  name: 'TableFeedback',
  props: ['data', 'columns', 'pickupBoxNames'],
  computed: {
    ...mapState('account', ['user']),
    ...mapState('pharmacy', ['pharmacy']),
    sortedData(): FeedbackType[] {
      if (!this.data) return [];

      const arr = Object.values(this.data) as FeedbackType[];

      arr.sort((a: FeedbackType, b: FeedbackType) => {
        if (a.label === this.$t('total')) return 1;
        if (b.label === this.$t('total')) return -1;
        return 0;
      });

      return arr;
    }
  },
  methods: {
    getTranslatedLabel(label: string, language: string): string {
      const translations =
        this.pharmacy?.feedbackTemplate.options_screen.options[label]
          ?.translations;

      return translations?.[language] || translations?.['en'] || label;
    },
    getName(item: string): string {
      if (this.pickupBoxNames && this.pickupBoxNames[item]) {
        return this.pickupBoxNames[item];
      }

      return this.getTranslatedLabel(item, this.user?.appLanguage);
    },
    getColumnValue(data: TableDataStatistics, column: Option) {
      switch (column.value) {
        case 'name':
          return this.getName(data.label);
        default:
          return data.data[column.value];
      }
    }
  }
})
export default class TableFeedback extends Vue {}
</script>

<style scoped lang="scss">
.scroll {
  overflow: auto;
  height: 100%;
  .tableFeedback {
    max-width: 600px;
    width: 100%;
    border-collapse: collapse;
    .thead {
      .column-main {
        text-align: left;
        .column-main-title {
          position: sticky;
          top: 0;
          font-family: 'Ubuntu-Medium';
          font-size: $tenSize;
          line-height: $thirteenSize;
          background: $white;
          color: $columnMainTitle;
          text-align: center;
          padding: 20px 10px;
          letter-spacing: 2px;
          .column-main-title-img {
            width: 70px;
            height: auto;
            object-fit: contain;
          }
          .column-main-title-sum {
            display: block;
            text-align: center;
            font-family: 'Ubuntu-Medium';
            font-size: $fourteenSize;
            line-height: $twentySize;
            font-weight: 600;
          }
        }
      }
    }
    .tbody {
      overflow-y: scroll;
      .column-content {
        border-top: 1px solid $borderTopLine;
        height: 46px;
        &:hover {
          cursor: pointer;
        }
        &:hover .column-content-title {
          background-color: $light-grey;
        }
        &:hover .column-content-title span {
          background-color: $light-grey;
        }

        .column-content-title {
          padding: 13px 10px;
          font-size: $fourteenSize;
          line-height: 20px;
          text-align: center;
          vertical-align: middle;
          color: $columnContentTitle;
          &:first-child {
            text-align: left;
          }
          .column-content-title-sum {
            font-family: 'Ubuntu-Medium';
            font-weight: 600;
          }
        }
      }
    }
    .observer {
      height: 10px;
      margin-top: 100px;
      background: transparent;
    }
  }
}

.table > :not(:first-child) {
  border-top: none;
}
</style>
